/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Partial_Underline_TooltipInputs */

const en_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for Events where some words or lines are underlined`)
};

const fr_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifier les evenements ou certains mots ou lignes sont soulignes`)
};

const de_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie, ob in bestimmten Ereignissen Wörter oder Zeilen unterstrichen sind.`)
};

const it_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla gli eventi in cui alcune parole o righe sono sottolineate`)
};

const ru_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте события, в которых некоторые слова или строки подчеркнуты.`)
};

const es_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobar eventos en los que algunas palabras o líneas estén subrayadas`)
};

const zh_cn2_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查事件中是否存在某些单词或行带有下划线的情况。`)
};

const ja_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一部の単語または行に下線が引かれているイベントを確認します`)
};

const hi_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन घटनाओं की जाँच करें जहाँ कुछ शब्द या पंक्तियाँ रेखांकित हैं।`)
};

const pt_pt2_style_guide_manager_partial_underline_tooltip = /** @type {(inputs: Style_Guide_Manager_Partial_Underline_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique os eventos em que algumas palavras ou linhas estão sublinhadas.`)
};

/**
* | output |
* | --- |
* | "Check for Events where some words or lines are underlined" |
*
* @param {Style_Guide_Manager_Partial_Underline_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_partial_underline_tooltip = /** @type {((inputs?: Style_Guide_Manager_Partial_Underline_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Partial_Underline_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "de") return de_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "it") return it_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "ru") return ru_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "es") return es_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "ja") return ja_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "hi") return hi_style_guide_manager_partial_underline_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_partial_underline_tooltip(inputs)
	return en_style_guide_manager_partial_underline_tooltip(inputs)
});